import { render, staticRenderFns } from "./CampaignsStopOnTextReply.vue?vue&type=template&id=d715e596&lang=pug"
import script from "./CampaignsStopOnTextReply.vue?vue&type=script&lang=js"
export * from "./CampaignsStopOnTextReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports